import React from 'react';

const AboutUs = () => {
  return (
    <section id="about-us" className="py-24 bg-gray-50 pt-10">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-medium text-gray-800 mb-12 text-center">About Us</h2>
        
        <div className="max-w-3xl mx-auto">
          <p className="text-gray-600 text-lg text-center mb-6">
            <span className="text-[#E57373]">Rock Dev</span> is the creative force behind <span className="text-[#E57373]">Chase the Chickens</span>. As a solo developer with a passion for innovative gaming experiences, he brings this unique pub-hunting game to life through clever design and technical expertise.
          </p>
          <p className="text-gray-600 text-lg text-center mb-6">
            His mission is to transform the traditional pub crawl into an exciting digital adventure that brings people together. Through careful attention to detail and a commitment to quality, he crafts every aspect of the game to ensure a seamless and enjoyable experience.
          </p>
          <p className="text-gray-600 text-lg text-center mb-8">
            Based in London, he draws inspiration from the city's vibrant pub culture and social scene. <span className="text-[#E57373]">Chase the Chickens</span> represents his vision of blending technology with real-world social interactions, creating memorable experiences for players across the city.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;